<template>
  <component
    :is="componentToUse"
    :current="current"
    :available="available"
    :editor-store-path="editorStorePath"
    @modifyAvailableLanguages="$emit('modifyAvailableLanguages', $event)"
  ></component>
</template>

<script>
import { mapState } from 'vuex';
import NxOneContentOneLanguageSelector
  from '@/modules/content/editor/components/languageSelector/OneContentOneLanguageSelector.vue';
import DefaultLanguageSelector from '@/modules/content/editor/components/languageSelector/DefaultLanguageSelector.vue';

export default {
  name: 'nx-content-editor-language-selector',
  props: {
    current: {
      type: String,
      required: true,
    },
    available: {
      type: Array,
      required: true,
    },
    editorStorePath: {
      type: [String, Array],
      required: true,
    },
  },
  computed: {
    ...mapState(['config']),
    componentToUse() {
      if (this.config.multilangMode === 'oneContentOneLanguage') {
        return NxOneContentOneLanguageSelector;
      }

      return DefaultLanguageSelector;
    },
  },
};
</script>
